import { Tooltip } from '@andritzot/metris-web-ui/data-display/tooltip';
import { Typography } from '@andritzot/metris-web-ui/data-display/typography';
import { Card, CardContent } from '@andritzot/metris-web-ui/surfaces/card';
import { v4 as uuidv4 } from 'uuid';

interface HelpWizardCardProps {
  title: string;
  tooltip: string;
  isSelected: boolean;
  key?: string;
  onClick?: () => void;
}

const HelpWizardCard = ({ title, tooltip, isSelected, key, onClick }: HelpWizardCardProps) => {
  const id = uuidv4().split('-')[0];
  return (
    <Tooltip key={key ?? id} title={tooltip ?? ''}>
      <Card
        sx={{
          height: 160,
          overflow: 'hidden',
          border: '1px solid',
          borderColor: isSelected ? 'primary.main' : 'divider',
          borderRadius: 1,
          bgcolor: isSelected ? 'primary.main' : 'background.paper',
          color: isSelected ? 'primary.contrastText' : 'text.primary',
          transition: 'border-color 0.15s, background-color 0.15s',
          boxShadow: 'none',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          '&:hover': {
            borderColor: 'primary.main',
            bgcolor: isSelected ? 'primary.dark' : 'primary.hover',
          },
        }}
        onClick={onClick}
      >
        <CardContent
          sx={{
            p: 2,
            '&:last-child': { pb: 2 },
            textAlign: 'center',
            wordBreak: 'break-word',
          }}
        >
          <Typography variant="cardHeading" sx={{ wordBreak: 'break-word', color: 'inherit' }}>
            {title}
          </Typography>
        </CardContent>
      </Card>
    </Tooltip>
  );
};

export default HelpWizardCard;
